export default __webpack_public_path__ + "static/media/timeStopper.170a6272.jpg";